import { render } from "./GatewayPageComercial.vue?vue&type=template&id=2d8f0a9a&scoped=true"
import script from "./GatewayPageComercial.vue?vue&type=script&lang=js"
export * from "./GatewayPageComercial.vue?vue&type=script&lang=js"

import "./GatewayPageComercial.vue?vue&type=style&index=0&id=2d8f0a9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8f0a9a"]])

export default __exports__